import React from "react";

const LibrarySong = ({
  song,
  setCurrentSong,
  isPlaying,
  audioRef,
  setLibraryStatus,
  activeSong,
}) => {
  const songSelectHandler = async () => {
    await setCurrentSong(song);

    activeSong(song);

    if (isPlaying) audioRef.current.play();
    setLibraryStatus(false);
  };
  return (
    <div
      onClick={songSelectHandler}
      className={`library-song ${song.active ? "selected" : ""}`}
    >
      <img src={song.cover} alt={song.name} />
      <div className="desc">
        <h3>{song.name}</h3>
        <h4>{song.artist}</h4>
      </div>
    </div>
  );
};

export default LibrarySong;
